import React from 'react';
import ButtonTwo from '../../components/Button/ButtonTwo';
import SingleServiceSix from '../../components/Service/SingleServiceSix';

import shapeImg from '../../assets/img/service/shape-5-1.png';
import serviceImg from '../../assets/img/service/service-5-1.jpg';

import serviceImg1 from '../../assets/img/service/serv1.jpg';
import serviceImg2 from '../../assets/img/service/serv2.jpg';
import serviceImg3 from '../../assets/img/service/serv3.jpg';
import serviceImg4 from '../../assets/img/service/serv4.jpg';
import serviceImg5 from '../../assets/img/service/serv5.jpg';
import serviceImg6 from '../../assets/img/service/serv6.jpg';
import serviceImg7 from '../../assets/img/service/serv7.jpg';
import serviceImg8 from '../../assets/img/service/serv8.jpg';
import serviceImg9 from '../../assets/img/service/serv9.jpg';

import '../../components/Service/SingleServiceFive.css';

const Service = () => {
  return (
    <div
      id="it-service"
      className="it-service-4-area z-index grey-bg-4 pt-120 pb-90"
    >
      <div className="it-service-4-shape-1 d-none d-xl-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="it-service-4-title-wrap mb-60">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="it-service-title-box">
                <span className="it-section-subtitle red-border">Our Services</span>
                <h3 className="it-section-title">
                  Take The Road To A <br /> Healthy Heart Beat
                </h3>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6">
              <div className="it-service-4-button text-md-end">
                <ButtonTwo
                  btnURL="/about-us"
                  btnClass="it-btn-theme red-bg mr-35"
                  btnText="Discover More"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
        <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <div className="single-service-six">
              <div className="service-image-container">
                <img src={serviceImg1} alt="Diagnostic Specialities" className="service-image" />
              </div>
              <div className="service-content">
                <div className="service-icon">
                  <i className="flaticon-microsurgery"></i>
                </div>
                <h4 className="service-title">Diagnostic Specialities</h4>
                <p className="service-description">
                  We offer a wide range of diagnostic specialties, including General Practitioners (GPs), Preventive Care, Interventional Cardiology, Pediatrics (PAEDS), Cardiac Surgery for Adults and Children, Gynaecology and Obstetrics for Cardiac Patients, and Dental Services tailored for Cardiac Patients.
                </p>
              </div>
            </div>
          </div>

          <div
  className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
  data-wow-duration=".9s"
  data-wow-delay=".5s"
>
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg2}
        alt="Emergency Care 24/7"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-pacemaker"></i>
      </div>
      <h4 className="service-title">Emergency Care 24/7</h4>
      <p className="service-description">
        Our services include 24/7 Care, Primary PCI, treatment for Pulmonary Embolism,
        Cardiac Syndrome, Stroke, Heart Failure, and Arrhythmia.
      </p>
    </div>
  </div>
</div>


            <div className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
     data-wow-duration=".9s"
     data-wow-delay=".7s">
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg3}
        alt="Diagnostic Cardiology"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-pacemaker"></i>
      </div>
      <h4 className="service-title">Diagnostic Cardiology</h4>
      <p className="service-description">
        We provide advanced imaging services including X-ray, Fluoroscopy, CT Angio,
        Cardiac MRI (CMR), and Thallium Scans for both Perfusion and Viability.
      </p>
    </div>
  </div>
</div>


<div
  className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
  data-wow-duration=".9s"
  data-wow-delay=".8s"
>
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg8}
        alt="Echo"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-heart"></i>
      </div>
      <h4 className="service-title">Echo</h4>
      <p className="service-description">
        Our echocardiography services include Transthoracic Echo, Fetal Echo, Transesophageal Echo, and Stereo Echo.
      </p>
    </div>
  </div>
</div>

          <div
  className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
  data-wow-duration=".9s"
  data-wow-delay="1s"
>
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg9}
        alt="Nutrition Services & Food Quality"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-pacemaker"></i>
      </div>
      <h4 className="service-title"><a href='/home-5'>Nutrition Services & Food Quality</a></h4>
      <p className="service-description">
        We also offer mental health services including Psychiatry and Psychology.
      </p>
    </div>
  </div>
</div>

<div
  className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
  data-wow-duration=".9s"
  data-wow-delay="1.1s"
>
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg3}
        alt="Infection Control Services"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-pacemaker"></i>
      </div>
      <h4 className="service-title">Infection Control Services</h4>
      <p className="service-description">
        We provide specialized Infection Control Services to ensure patient safety and prevent the spread of infections.
      </p>
    </div>
  </div>
</div>

<div
  className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
  data-wow-duration=".9s"
  data-wow-delay="1.1s"
>
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg7}
        alt="Nephrology Services For Cardiac Patients"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-pacemaker"></i>
      </div>
      <h4 className="service-title">Nephrology Services For Cardiac Patients</h4>
      <p className="service-description">
        Our comprehensive Nephrology Services address kidney-related conditions with expert care and advanced diagnostics.
      </p>
    </div>
  </div>
</div>

<div
  className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
  data-wow-duration=".9s"
  data-wow-delay="1.1s"
>
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg4}
        alt="Physiotherapy and Rehabilitation Services"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-pacemaker"></i>
      </div>
      <h4 className="service-title">Physiotherapy and Rehabilitation Services</h4>
      <p className="service-description">
        We offer dedicated Physiotherapy and Rehabilitation Services to support recovery, mobility, and overall physical well-being.
      </p>
    </div>
  </div>
</div>

<div
  className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
  data-wow-duration=".9s"
  data-wow-delay="1.1s"
>
  <div className="single-service-six">
    <div className="service-image-container">
      <img
        src={serviceImg}
        alt="Methology"
        className="service-image"
      />
    </div>
    <div className="service-content">
      <div className="service-icon">
        <i className="flaticon-pacemaker"></i>
      </div>
      <h4 className="service-title">Methology</h4>
      <p className="service-description">
        We offer dedicated Methology Services to support recovery, blood, and overall health well-being.
      </p>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default Service;
